export const appConfig = {
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL,
  // Used for server-to-server calls (e.g. RSC/layout fetches to our own API).
  // Avoids routing same-box requests out through the public domain/CDN on every navigation.
  internalBaseUrl: process.env.INTERNAL_API_URL || process.env.NEXT_PUBLIC_BASE_URL
};
